import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { Box, Link } from "@mui/material";

PartidoCardVoley.propTypes = {
  partido: PropTypes.object,
  type: PropTypes.string,
  links: PropTypes.array
};

export default function PartidoCardVoley({ partido, type = "resultado", links = [] }) {
  const [link, setLink] = useState("");

  useEffect(() => {
    const linkCancha = links.find((l) => l.cancha === partido.cancha);
    if (linkCancha) setLink(linkCancha.url);
  }, [links, partido.cancha]);

  // Armar sets disponibles
  const sets = [
    { local: partido.set_local_1, visitante: partido.set_visitante_1 },
    { local: partido.set_local_2, visitante: partido.set_visitante_2 },
    { local: partido.set_local_3, visitante: partido.set_visitante_3 },
  ].filter((s) => s.local && s.visitante);

  return (
    <Card
      sx={{
        width: 350,
        height: "auto",
        mb: 1,
        mr: 3,
        border: 1,
        borderColor: "divider",
        cursor: "pointer",
        transition: "0.2s",
        "&:hover": { boxShadow: 4 },
      }}
      onClick={() => console.log(partido.id)}
    >
      <CardContent sx={{ p: 1.5 }}>
        {/* Categoría */}
        <Typography
          color="secondary"
          sx={{
            fontWeight: "bold",
            fontFamily: "sans-serif",
            textAlign: "center",
            fontSize: 18,
            mb: 1,
          }}
        >
          {partido.category}
        </Typography>

        {/* Encabezado de sets */}
        {type === "resultado" && sets.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 2 }}>
            {sets.map((_, i) => (
              <Typography
                key={i}
                sx={{
                  width: 40,
                  textAlign: "center",
                  fontSize: 13,
                  fontWeight: "bold",
                  color: "gray",
                }}
              >
                Set {i + 1}
              </Typography>
            ))}
          </Box>
        )}

        {/* Filas de equipos y sus sets */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {/* Equipo local */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: 15, fontWeight: "bold", flex: 1 }}>
              {partido.equipo_local}{" "}
              <Typography component="span" sx={{ fontWeight: "normal" }}>
                ({partido.sets_local ?? 0})
              </Typography>
            </Typography>
            {sets.map((s, i) => (
              <Typography
                key={`local-${i}`}
                sx={{ width: 40, textAlign: "center", fontSize: 15 }}
              >
                {s.local}
              </Typography>
            ))}
          </Box>

          {/* Equipo visitante */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontSize: 15, fontWeight: "bold", flex: 1 }}>
              {partido.equipo_visitante}{" "}
              <Typography component="span" sx={{ fontWeight: "normal" }}>
                ({partido.sets_visitante ?? 0})
              </Typography>
            </Typography>
            {sets.map((s, i) => (
              <Typography
                key={`visitante-${i}`}
                sx={{ width: 40, textAlign: "center", fontSize: 15 }}
              >
                {s.visitante}
              </Typography>
            ))}
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Cancha y link */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontWeight: "bold" }} color="primary.blue">
            Cancha: {partido.cancha}
          </Typography>
          {link && (
            <Link
              href={link}
              target="_blank"
              color="secondary"
              underline="none"
              sx={{ fontWeight: "bold", fontFamily: "sans-serif" }}
            >
              Ver Partido
            </Link>
          )}
        </Box>

        {/* Fecha y hora */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
          <Typography sx={{ fontWeight: "bold", textDecoration: "underline" }}>
            Fecha: {partido.fecha}
          </Typography>
          <Typography
            color="primary.blue"
            sx={{ fontWeight: "bold", textDecoration: "underline" }}
          >
            Hora: {partido.hora}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}